import { FormGroupState } from 'ngrx-forms'
import { createSelector } from '@ngrx/store'
import { AccountState, PendingState, selectAccountState } from '../account.root.state'

export type PaymentMethods = DebitCharge | CreditCard | PayPal

export interface PaymentMethod {
  type: PaymentMethodType
}

type PaymentMethodType = 'sepa' | 'paypal' | CreditCardType | 'invoice'
export type CreditCardType = 'mastercard' | 'visa'

export interface DebitCharge extends PaymentMethod {
  owner: string
  iban: string
  bic: string
  bank: string
  mandateReference: string
  sepaAgreement: boolean
  sepaConditions: boolean
}

export interface CreditCard extends PaymentMethod {
  cardHolderName: string
  creditCardNumber: string
}

export interface PayPal extends PaymentMethod {
  email: string
}

export interface PaymentMethodsState {
  newDebitChargeControls: FormGroupState<Omit<DebitCharge, 'mandateReference'>>
  editPaymentMethodControls: FormGroupState<DebitCharge>
  loadedPaymentMethodToEdit: PendingState | undefined
  paymentMethodToEdit: DebitCharge
}

export const selectPaymentMethodsState = {
  paymentMethodsState: createSelector(
    selectAccountState,
    (state: AccountState): PaymentMethodsState => state.paymentMethodsState,
  ),
  newDebitChargeControls: createSelector(
    selectAccountState,
    (state: AccountState): FormGroupState<Omit<DebitCharge, 'mandateReference'>> =>
      state.paymentMethodsState.newDebitChargeControls,
  ),
  editPaymentMethodsControls: createSelector(
    selectAccountState,
    (state: AccountState): FormGroupState<DebitCharge> => state.paymentMethodsState.editPaymentMethodControls,
  ),
  paymentMethodToEdit: createSelector(
    selectAccountState,
    (state: AccountState): DebitCharge => state.paymentMethodsState.paymentMethodToEdit,
  ),
  loadedPaymentMethodToEdit: createSelector(
    selectAccountState,
    (state: AccountState): PendingState | undefined => state.paymentMethodsState.loadedPaymentMethodToEdit,
  ),
} as const
